import { Switch } from "@mantine/core";
import useStyles  from "_styles/atoms/antSwitch";
import React      from "react";

const component = props => {
	const { checked, onChange, classNames, ...otherProps } = props;

	const { classes, cx } = useStyles ( { checked }, { name: "styles" } );

	return (
		<Switch
			checked  = { checked }
			classNames = { {
				root       : cx ( classNames?.root, classes.root ),
				switchBase : cx ( classNames?.switchBase, classes.switchBase ),
				thumb      : cx ( classNames?.thumb, classes.thumb ),
				track      : cx ( classNames?.track, classes.track ),
				checked    : cx ( classNames?.checked, classes.checked ),
				input      : cx ( classNames?.input, classes.input )
			} }
			data-checked = { checked ? checked : undefined }
			onChange = { onChange }
			size = "xl"
			{ ...otherProps }
		/>
	);
};

export default component;
